import React, { useState, useEffect } from "react";
import { bookingDetail } from "../../services/bookingServices";
import { useParams } from "react-router-dom";
import SuccessAlert from "../child/Alert/SuccessAlert";
import DengerAlert from "../child/Alert/DengerAlert";

const ViewBookingPageNew = () => {
  const { id } = useParams();
  const [item, setItem] = useState(null);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await bookingDetail(id);
      setItem(response?.data?.booking || null);
    } catch (error) {
      console.error(error);
      setErrorMessage("Failed to fetch booking detail");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) fetchData();
  }, [id]);

  // ✅ Helper for formatting date
  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    return `${date.getDate().toString().padStart(2, "0")}/${(
      date.getMonth() + 1
    )
      .toString()
      .padStart(2, "0")}/${date.getFullYear()}`;
  };

  return (
    <div className="row gy-4">
      <div className="col-md-12">
        <div className="card h-100">
          <div className="card-body p-24">
            {successMessage && (
              <SuccessAlert
                message={successMessage}
                onClose={() => setSuccessMessage("")}
              />
            )}
            {errorMessage && (
              <DengerAlert
                message={errorMessage}
                onClose={() => setErrorMessage("")}
              />
            )}

            {loading ? (
              <p>Loading...</p>
            ) : item ? (
              <>
                <div className="row mb-3">
                  <div className="col-md-3">
                    <p>
                      <strong>User Name:</strong> {item?.userData?.fullName}
                    </p>
                  </div>
                  <div className="col-md-3">
                    <p>
                      <strong>Event:</strong> {item?.eventData?.name}
                    </p>
                  </div>
                   <div className="col-md-3">
                    <p>
                      <strong>Host Name:</strong> {item?.hostData?.fullName}
                    </p>
                  </div>
                  <div className="col-md-3">
                    <p>
                      <strong>Booking Date:</strong>{" "}
                      {formatDate(item.createdAt)}
                    </p>
                  </div>
                   <div className="col-md-3">
                    <p>
                      <strong>Booking Start Date:</strong>{" "}
                      {formatDate(item.bookingStartDate)}
                    </p>
                  </div>
                   <div className="col-md-3">
                    <p>
                      <strong>Booking End  Date:</strong>{" "}
                      {formatDate(item.bookingEndDate)}
                    </p>
                  </div>
                  <div className="col-md-3">
                    <p>
                      <strong>Members:</strong> {item.members}
                    </p>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-3">
                    <p>
                      <strong>Booth Cost:</strong> {item.boothCost}
                    </p>
                  </div>
                  <div className="col-md-3">
                    <p>
                      <strong>Ticket Cost:</strong> {item.ticketCost}
                    </p>
                  </div>
                  <div className="col-md-3">
                    <p>
                      <strong>Ticket Type:</strong> {item.ticketType}
                    </p>
                  </div>
                  <div className="col-md-3">
                    <p>
                      <strong>Discount:</strong> {item.discount}
                    </p>
                  </div>
                   <div className="col-md-3">
                    <p>
                      <strong>Total Amount:</strong> {item.totalAmount}
                    </p>
                  </div>
                   <div className="col-md-3">
                    <p>
                      <strong>Admin Comission:</strong> {item.adminFee}
                    </p>
                  </div>
                  <div className="col-md-3">
                    <p>
                      <strong>Admin Payout:(HST + Admin Comission) </strong> {item.adminPayout}
                    </p>
                  </div>
                   <div className="col-md-3">
                    <p>
                      <strong>Host Payout:</strong> {Math.round(item.hostPayout * 100) / 100}
                    </p>
                  </div>
                   <div className="col-md-3">
                    <p>
                      <strong>HST:</strong> {item.fees}
                    </p>
                  </div>
                     {/* <div className="col-md-3">
                    <p>
                      <strong>Transaction Info:</strong> {item.transactionInfo}
                    </p>
                  </div> */}
                  <div className="col-md-3">
                    <p>
                      <strong>Status:</strong> {item.status}
                    </p>
                  </div>
                </div>
              </>
            ) : (
              <p>No data found.</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewBookingPageNew;
